import { ComponentProps, ReactNode, createContext } from 'react';
import AlertDialog from '#shared/components/AlertDialog/AlertDialog';

export type AlertDialogProps = ComponentProps<typeof AlertDialog>;
export type AlertDialogResult = 'confirm' | 'abort' | 'close';
export type AlertDialogOptions = Pick<
  AlertDialogProps,
  'abortLabel' | 'confirmLabel' | 'top' | 'bottom' | 'closeButton'
>;

export type AlertDialogMethod = (
  title: ReactNode,
  content: ReactNode,
  options?: AlertDialogOptions,
) => Promise<AlertDialogResult>;

export type AlertDialogService = {
  open: AlertDialogMethod;
  success: AlertDialogMethod;
  caution: AlertDialogMethod;
  error: AlertDialogMethod;
  close: () => void;
};

export const AlertDialogContext = createContext<AlertDialogService | null>(null);
